import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["select", "emailId", "faxId", "addressId", "methodField", "secureToggleWrapper"]

  connect() {
    this.syncFromSelected()
  }

  change() {
    this.syncFromSelected()
    this.dispatch("methodChanged")
  }

  syncFromSelected() {
    if (!this.hasSelectTarget) return

    const opt = this.selectTarget.options[this.selectTarget.selectedIndex]
    if (!opt) return

    this.emailIdTarget.value = opt.dataset.emailId || ""
    this.faxIdTarget.value = opt.dataset.faxId || ""
    this.addressIdTarget.value = opt.dataset.addressId || ""
    this.methodFieldTarget.value = opt.dataset.method
    if (this.hasSecureToggleWrapperTarget) {
      this.secureToggleWrapperTarget.classList.toggle("hidden", opt.dataset.method !== "email")
    }
  }
}
